import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  count: 0,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.count = action.payload;
    },
    incrementCount: (state) => {
      state.count += 1;
    },
    decrementCount: (state) => {
      state.count = Math.max(0, state.count - 1);
    },
    resetCount: (state) => {
      state.count = 0;
    },
  },
});

export const { setCount, incrementCount, decrementCount, resetCount } = notificationSlice.actions;
export default notificationSlice.reducer;

